(ns ycweb.app.admin.wholesale.importorders.importorders
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]))

(def datatable-import-order-key :admin.wholesale/import-orders.table)
(def editor-import-order-key :admin.wholesale/import-orders.editor)

(defn import-order-overview-link [app-atom row col v]
  (w.cmn/overview-link app-atom
    {:entity-uuid v
     :permission "SiteAdmin:Wholesale:ImportOrder:View"
     :action "import_order_overview"}))

(defn stock-order-overview-link [app-atom row col v]
  (w.cmn/overview-link app-atom
    {:entity-uuid (:stock-order/uuid row)
     :permission "SiteAdmin:Wholesale:StockOrder:View"
     :action "stockorder_overview"
     :display-value (:import-order/reference row)}))

(defn import-no-fn [app-atom row col v]
  (str "IO-" v))

(defn origin-country-fn [app-atom row col v]
  (str
    (:import-order/origin-country row)
    " - "
    (:import-order/lading-locode row)))

(defn import-country-fn [app-atom row col v]
  (str
    (:import-order/import-country row)
    " - "
    (:import-order/discharge-locode row)))

(rum/defc csv-download < rum/reactive [app-atom {:keys [table-name selected-row-ids]}]
  (let [table-atom (datatables/table-cursor app-atom table-name)]
    [:div
     {:class (yuc/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      [:form {:name "importorder-report-form" :action "/api/admin/reports/importorders" :method "GET" :target "_blank"}
       (forms/input-raw ""
         (rum/cursor table-atom :select)
         {:type :hidden :name "importorder-ids" :required? true})
       (buttons/button-web "CSV"
         {:type :submit
          :disabled (zero? (count selected-row-ids))
          :style :primary})]]]))

(defn update-freight-suppliers [app-atom editor-atom selected-value]
  (let [action-atom (cmn/action-cursor app-atom)
        supplier-list (cmn/curact action-atom [:suppliers-by-freight-forwarder (trf/tonumber selected-value)])]
    (editor/post-comms app-atom editor-import-order-key
      {:options
       {:import-order/supplier-id (or supplier-list [])}})))

(defn display-supplier-country [app-atom option-value]
  (str (:country/code option-value) " - " (:country/name option-value)))

(defn render-supplier-country [app-atom input-atom cfg item]
  (str (:country/code item) " - " (:country/name item)))

(defn order-po-fn [app-atom row col v]
  (:import-order/reference row))

(defn datatable-fns [app-atom]
  {:editor
   {:form
    {:fields
     {:import-order/freight-forwarder-id
      {:change-fn update-freight-suppliers}
      :import-order/supplier-country-id
      {:display-fn display-supplier-country
       :item-render-fn render-supplier-country}}}}
   :column-fns
   {:edit-fn import-order-overview-link
    :import-no-fn import-no-fn
    :stockorder-overview-fn stock-order-overview-link
    :order-po-fn order-po-fn
    :origin-country-fn origin-country-fn
    :import-country-fn import-country-fn}
   :button-fns
   {:csv-fn (partial csv-download)}})

(def editor-config
  {:editor-name editor-import-order-key
   :datatable datatable-import-order-key
   :mode :read
   :style
   {:width :xlarge
    :columns 3}
   :end-points
   {:create :admin.wholesale/import-orders.add}
   :fields
   [{:label "Freight Forwarder*:"
     :name :import-order/freight-forwarder-id
     :type :select
     :attr
     {:placeholder "- Select a Freight Forwarder -"
      :type :number}
     :opts-cfg
     {:lookup
      {:value :freight-forwarder/id :text :freight-forwarder/name}}}
    {:label "Supplier*:"
     :name :import-order/supplier-id
     :type :select
     :attr
     {:placeholder "- Select a Supplier -"
      :hint "Filtered based on selected Freight Forwarder"
      :type :number}
     :opts-cfg
     {:lookup
      {:value :supplier/id :text :supplier/name}}}
    {:label "Warehouse*:"
     :name :import-order/destination-id
     :type :select
     :attr
     {:placeholder "- Select a Warehouse -"
      :type :number}
     :opts-cfg {:lookup {:value :warehouse/id :text :warehouse/name}}}
    {:label "Supplier Country:"
     :name :import-order/supplier-country-id
     :type :select-search
     :attr
     {:placeholder "- Select a Supplier Country -"
      :type :number}
     :opts-cfg {:lookup {:value :country/id :text :country/name}}}
    {:label "Origin Country:"
     :name :import-order/origin-country-id
     :type :select
     :attr
     {:placeholder "- Select a Origin Country -"
      :type :number}
     :opts-cfg {:lookup {:value :country/id :text :country/name}}}
    {:label "Import Country:"
     :name :import-order/import-country-id
     :type :select
     :attr
     {:placeholder "- Select a Import Country -"
      :type :number}
     :opts-cfg {:lookup {:value :country/id :text :country/name}}}
    {:label "Billing Currency:"
     :name :import-order/currency-id
     :type :select
     :attr
     {:placeholder "- Select a Billing Currency -"
      :type :number}
     :opts-cfg {:lookup {:value :currency/id :text :currency/display-name}}}
    {:label "Import Type:"
     :name :import-order/transport-mode
     :type :select
     :attr {:placeholder "- Select an Import Type -"}}
    {:label "IncoTerm:"
     :name :import-order/inco-term-id
     :type :select
     :attr
     {:placeholder "- Select an IncoTerm -"
      :type :number}
     :opts-cfg {:lookup {:value :incoterm/id :text :incoterm/display-name}}}
    {:name :import-order/uuid
     :attr
     {:type :hidden}}]})

(defmethod comms/receive :admin.wholesale/import-orders.add [app-atom e]
  (let [{:keys [success]} (editor/post-submit app-atom editor-import-order-key e)]
    (when success
      (datatables/update-rows app-atom datatable-import-order-key e))))

(defn import-orders-table-config [app-atom]
  (let [action-atom-path (cmn/action-cursor-path app-atom)
        action-atom (cmn/action-cursor app-atom)
        dear-sync (cmn/curact action-atom :dear-sync/method)
        generic-cfg
        (yuc/maybe assoc
          {}
          :editor (when (= dear-sync :push) editor-import-order-key)
          :action
          (when
            (or
              (nil? dear-sync)
              (= dear-sync :pull))
            :admin.wholesale/wholesale.editor-disabled)
          :description
          (when (= dear-sync :push)
            "Fields marked with * are required")
          :config
          (cond
            (= dear-sync :pull)
            {:title "The system is set to sync from Dear"
             :msg "The system is set to pull from Dear, Import Order creation has been disabled."}

            (nil? dear-sync)
            {:title "Unknown error occurred"}))

        create-cfg (merge {:text "Create" :extends :create} generic-cfg)]

    {:table-name datatable-import-order-key
     :row-id :import-order/id
     :data-source {:cursor [action-atom-path :import-orders.table]}
     :select? {:style :os}
     :options
     {:order :desc
      :sort-title "Order #"
      :paging? true
      :pagination {:page 0 :page-size 20}}
     :buttons
     [create-cfg
      {:text "CSV"
       :component-fn :csv-fn}]
     :column-defs
     [{:key :import-order/id
       :type :selector}
      {:key :import-order/id
       :title "Order #"
       :align-class :u-text-center
       :render
       {:render-k :import-no-fn}}
      {:key :import-order/reference
       :title "PO #"
       :align-class :u-text-center
       :render
       {:logic-k :order-po-fn
        :render-k :stockorder-overview-fn}}
      {:key :import-order/freight-forwarder
       :title "Freight Forwarder"
       :align-class :u-text-center}
      {:key :import-order/supplier-name
       :title "Supplier"}
      {:key :import-order/status
       :title "Status"}
      {:key :import-order/origin-country
       :title "Origin Details"
       :align-class :u-text-center
       :render
       {:logic-k :origin-country-fn}}
      {:key :import-order/import-country
       :title "Import Details"
       :align-class :u-text-center
       :render
       {:logic-k :import-country-fn}}
      {:key :import-order/order-date
       :title "Order Date"
       :type :date
       :dateformat "dd/MM/yyyy"
       :align-class :u-text-center}
      {:key :import-order/expected-landing-date
       :title "Expected Landing Date"
       :type :date
       :dateformat "dd/MM/yyyy"
       :align-class :u-text-center}
      {:key :import-order/transport-mode
       :title "Transport Mode"}
      {:key :import-order/inco-term
       :title "Incoterm"}
      {:key :import-order/uuid
       :title "Overview"
       :render
       {:render-k :edit-fn}
       :align-class :u-text-center}]}))

(rum/defc import-order-list < rum/reactive [app-atom]
  (list
    [:div
     {:class (yuc/bem :flex-grid-group [:flush :align-left :valign-middle])}]
    (datatables/table app-atom datatable-import-order-key (datatable-fns app-atom))))

(defmethod flow/render-screen :admin.wholesale/import_orders [app-atom _]
  [:div {:style {:position "relative"}}
   [:div {:style {:position "absolute" :top 0 :right 0 :z-index 1}}
    (buttons/button-web "Try new layout"
      {:href "wholesale.htm?action=import_orders&v2=1"
       :on-click #(w.cmn/save-admin-layout-preference! app-atom "wholesale.import_orders" "new")
       :style :light
       :size :small})]
   (w.cmn/wholesale-wrapper app-atom
     {:main-page "Import Orders"
      :confirm-leave false
      :confirm-leave-modal-key :admin.wholesale/check.unsaved-changes}
     (import-order-list app-atom))])

(defmethod t/transition-open :admin.wholesale/import_orders [app-atom _ params]
  (when-not (w.cmn/redirect-to-new-layout-if-needed! app-atom "wholesale.import_orders" params)
    (comms/send :admin.wholesale/import-orders.setup {})))

(defmethod t/transition-after-open :admin.wholesale/import_orders [app-atom _ _]
  (dcommon/kill-search-bar)
  (presence/open app-atom {:context/ident :admin.wholesale/import-orders})
  (datatables/initiate app-atom (import-orders-table-config app-atom) (datatable-fns app-atom))
  (editor/initiate app-atom editor-config)
  (grid/dispatch-action app-atom :admin.wholesale/import-orders.list {}))

(defmethod comms/receive :admin.wholesale/import-orders.setup [app-atom response]
  (let [action-atom (cmn/action-cursor app-atom)]
    (swap! action-atom assoc
      :dear-sync/method (:dear-sync/method response))))

(defmethod grid/action :admin.wholesale/import-orders.list [app-atom config {}]
  (comms/send :admin.wholesale/import-orders.list {})
  (datatables/overlay app-atom :open datatable-import-order-key))

(defmethod comms/receive :admin.wholesale/import-orders.list [app-atom {:keys [rows options freight-suppliers]}]
  (let [action-atom (cmn/action-cursor app-atom)
        freight-suppliers-gpd (group-by :supplier/freightforwarder_id freight-suppliers)]
    (swap! action-atom assoc :suppliers-by-freight-forwarder freight-suppliers-gpd)
    (datatables/overlay app-atom :close datatable-import-order-key)
    (datatables/post-comms app-atom datatable-import-order-key {:rows rows})
    (editor/post-comms app-atom editor-import-order-key {:options options})))
